import { rc } from "./rc";

export const employee_voice_extracts = {
  rc,
};
